var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCameraEmpty = function SvgCameraEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.75 5.5H3.667c-1.013 0-1.834.82-1.834 1.833v7.334c0 1.012.821 1.833 1.834 1.833H13.75c1.012 0 1.833-.82 1.833-1.833v-.786l3.212 1.835a.916.916 0 0 0 1.372-.796V7.08a.917.917 0 0 0-1.372-.796l-3.212 1.835v-.786c0-1.012-.82-1.833-1.833-1.833Zm0 3.667v5.5H3.667V7.333H13.75v1.834Zm4.583 4.174-2.75-1.572v-1.538l2.75-1.572v4.682Z"
  })));
};

export default SvgCameraEmpty;